var map = {
	"./calendar.png": "0799",
	"./calendar_active.png": "979e",
	"./calendar_person.png": "4031",
	"./calendar_person_active.png": "e496",
	"./tasks.png": "e456",
	"./tasks_active.png": "0d1d",
	"./tasks_person.png": "3278",
	"./tasks_person_active.png": "1be4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "adfe";